import React, { useEffect, useState } from 'react';
import { serviceBundler } from '../../App';
import {
  Button,
  Card,
  Col,
  Collapse,
  Divider,
  Layout,
  Row,
  Space,
  theme,
} from 'antd';
import { Content, Footer, Header } from 'antd/es/layout/layout';
import { PlusCircleOutlined, ArrowsAltOutlined } from '@ant-design/icons';

import style from './LanguagePage.module.css';
import { useNavigate } from 'react-router-dom';
import { RenderCardTitle } from '../../Components/Translation/RenderCardTitle';
import { AddLanguageConfig } from '../../Components/Translation/AddLanguageConfig';
import { Language } from '../../Models/Language/Language';
import { useTranslation } from 'react-i18next';
import HeaderBar from '../../Components/Header/HeaderBar';
import { min } from 'moment';
import { SortableList } from '../../Components/SortableList';
import styled from 'styled-components';
import FooterBar from '../../Components/Footer/FooterBar';

const PageWrapper = styled.div`
  .SortableItem {
    display: flex;
    justify-content: space-between;
    flex-grow: 1;
    align-items: center;
    background-color: #fff;
    box-shadow:
      0 0 0 calc(1px / var(--scale-x, 1)) rgba(63, 63, 68, 0.05),
      0 1px calc(3px / var(--scale-x, 1)) 0 rgba(34, 33, 81, 0.15);
    border-radius: calc(10px / var(--scale-x, 1));
    box-sizing: border-box;
    list-style: none;
    color: #333;
    font-weight: 400;
    font-size: 1rem;
    font-family: sans-serif;
    flex-direction: row;
    max-width: 400px;
    min-width: 400px;
  }

  .SortableList {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 10px;
    padding: 0;
    list-style: none;
    border-radius: 20px;
    flex-wrap: wrap;
    justify-content: stretch;
    flex-grow: 0;
  }
`;

const { useToken } = theme;

const LanguagePage = () => {
  const { i18n, t } = useTranslation();
  const { token } = useToken();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModelEditMode, setModelEditMode] = useState(false);

  const [languages, setLanguages] = useState<Language[]>([]);
  const [language, setLanguage] = useState<Language>();

  const navigate = useNavigate();

  const NavigateToLabel = (item: Language) => {
    navigate(`/languages/${item.languageKey}`, {
      state: {},
    });
  };

  const ShowModalForEdit = (item: Language) => {
    setLanguage(item);
    setModelEditMode(true);
    setIsModalOpen(true);
  };

  const showModalForAdd = () => {
    setLanguage(undefined);
    setIsModalOpen(true);
    setModelEditMode(false);
  };

  const handleCancelForm = () => {
    setIsModalOpen(false);
  };

  const SafeSoftwareSetting = async (props: Language) => {
    console.log('SafeSoftwareSetting', props);
    if (props.id !== undefined) {
      serviceBundler.languageService.UpdateLanguage(props);
    } else {
      if (serviceBundler.languageService.languages == null) {
        serviceBundler.languageService.languages = [props];
      } else {
        await serviceBundler.languageService.AddLanguage(props);
      }
    }
    setIsModalOpen(false);
  };

  const RemoveLanguage = (props: Language) => {
    serviceBundler.languageService.DeleteLanguage(props);
    setIsModalOpen(false);
  };

  const RenderTitle = (item: Language) => {
    if (item == undefined) {
      return <></>;
    }

    return RenderCardTitle(
      item.languageKey,
      item.languageName,
      <ArrowsAltOutlined />,
      NavigateToLabel,
      ShowModalForEdit,
      item,
    );
  };

  useEffect(() => {
    serviceBundler.languageService.GetFetchStatus().subscribe((value) => {
      if (!value) {
        return;
      }

      FetchData();
    });
  }, [0]);

  const FetchData = async () => {
    var fetechItems = await serviceBundler.languageService.GetLanguages();
    if (fetechItems !== undefined) {
      setLanguages(fetechItems);
    }
  };

  const GetNumberTranslations = (item: Language) => {
    if (item.keysLabels != null) {
      return Object.keys(item.keysLabels).length;
    }
    return 0;
  };

  const ChangeOrderDevices = (items: Language[]) => {
    var reorderedItems = serviceBundler.languageService.ReplaceLanguages(items);
    setLanguages(reorderedItems);
  };

  return (
    <Space direction="vertical" style={{ width: '100%' }} size={[0, 48]}>
      <Layout>
        <Header className={style.headerStyle}>
          <HeaderBar></HeaderBar>
        </Header>

        <Content
          style={{ backgroundColor: token?.colorPrimaryBg }}
          className={style.headerBlock}
        >
          <div className={style.middleBlock}>
            <Divider orientation="center">{t('allAvailLangu')}</Divider>
            <div className={style.contentBlock}>
              {/* <PageWrapper>
                <SortableList
                  items={languages ? languages : []}
                  onChange={ChangeOrderDevices}
                  renderItem={(item) => (
                    <SortableList.Item id={item.id}>
                      <div style={{ width: 350 }}>
                        <Col>
                          <Card title={RenderTitle(item)} variant="outlined">
                            {GetNumberTranslations(item)}{' '}
                            {t('translations').toLowerCase()}
                          </Card>
                        </Col>
                      </div>
                      <SortableList.DragHandle />
                    </SortableList.Item>
                  )}
                />
              </PageWrapper> */}
              {languages.map((item: Language, i) => (
                <div style={{ minWidth: 350, margin: 20 }} key={i}>
                  <Col>
                    <Card title={RenderTitle(item)}>
                      {GetNumberTranslations(item)}{' '}
                      {t('translations').toLowerCase()}
                    </Card>
                  </Col>
                </div>
              ))}
            </div>
            <Space
              direction="horizontal"
              style={{
                width: '100%',
                marginTop: '20px',
                justifyContent: 'right',
              }}
            >
              <Button
                type="primary"
                icon={<PlusCircleOutlined />}
                onClick={showModalForAdd}
              >
                {t('add')}
              </Button>
              <AddLanguageConfig
                allData={languages}
                data={language}
                open={isModalOpen}
                onCancel={handleCancelForm}
                onSafe={SafeSoftwareSetting}
                onRemove={RemoveLanguage}
                onEdit={isModelEditMode}
              ></AddLanguageConfig>
            </Space>
          </div>
        </Content>
        <Footer className={style.footerStyle}>
          <FooterBar></FooterBar>
        </Footer>
      </Layout>
    </Space>
  );
};

export default LanguagePage;
